import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import MeetingParticipantCard from "./MeetingParticipantCard";

function MeetingParticipants() {
  useEffect(() => {
    const slider = document.querySelector(".participants");
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
      console.log(walk);
    });
  }, []);

  let list = [
    { name: "Tomson Solomon", active: true, muted: false, id: "1" },
    { name: "Gift Solomon", muted: true, id: "2" },
    { name: "Alabi John Solomon", muted: true, id: "3" },
    { name: "Kate Solomon", muted: true, id: "4" },
    { name: "Emmanuel Solomon", muted: true, id: "5" },
    { name: "Temi tola", muted: true, id: "6" },
    { name: "Gabriel Tolu", muted: true, id: "7" },
    { name: "Falako Taiwo", muted: true, id: "8" },
  ];

  return (
    <>
      <style>
        {`
        /* Hide scrollbar for Chrome, Safari and Opera */
        .participants::-webkit-scrollbar {
        display: none;
        }

        /* Hide scrollbar for IE, Edge and Firefox */
        .participants {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
}
        `}
      </style>
      <Flex
        flexDirection={"row"}
        className="participants"
        alignItems={"center"}
        gap="20px"
        flexWrap={"nowrap"}
        overflowX="scroll"
        pb="20px"
      >
        {list?.map((data) => (
          <MeetingParticipantCard {...data} />
        ))}
      </Flex>
    </>
  );
}

export default MeetingParticipants;
